export default "__VITE_ASSET__2911ab86__"